import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

import { PostHogProvider } from '@posthog/react';
import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById("root"));
const consent = localStorage.getItem('posthog_consent') === 'true';

root.render(
  <React.StrictMode>
    <HelmetProvider>
      {consent ? (
        <PostHogProvider 
          apiKey={process.env.REACT_APP_POSTHOG_KEY}
          options={{ api_host: process.env.REACT_APP_POSTHOG_HOST }}
        >
          <App />
        </PostHogProvider>
      ) : (
        <App />
      )}
    </HelmetProvider>
  </React.StrictMode>
);
